<template>
  <div class="h-full w-full" />
</template>
